import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { OAuthAuthorize } from "@components/oauth/authorization/OAuthAuthorize";
import { OAuthCallback } from "@components/oauth/authorization/OAuthCallback";
import { Subscribe } from "../billing/Subscribe";
import { Onboarding } from "./Onboarding";

export const OnboardingRoutes: React.FC = () => (
    <Routes>
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />

        <Route path="/oauth">
            <Route path="authorize/:service" element={<OAuthAuthorize />} />
            <Route path="callback/:service" element={<OAuthCallback />} />
        </Route>

        <Route path="/subscribe/:plan" element={<Subscribe />} />
    </Routes>
);
